import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import useLeads, { CDS_LEADS_QUERY } from '../crossDomainSearch/leads/useLeads';
export const LEADS_UNREAD_COUNT_QUERY = `${CDS_LEADS_QUERY}/unread-count`;

const useLeadsUnreadCount = (): [number | undefined, RequestStateQuery] => {
  const searchParams = new URLSearchParams();
  searchParams.set('readByBranch', 'false');
  const [data, { isLoading, isSuccess, isError }] = useLeads({
    overrideSearchParams: searchParams,
  });
  return [data?.total_hit_count, { isLoading, isSuccess, isError }];
};

export default useLeadsUnreadCount;
